import styled from '@emotion/styled'

import { Asable } from '../../../../types/asable'

type FormattedElementWrapperProps = Asable

export const FormattedElementWrapper = styled.span<FormattedElementWrapperProps>``
